import { combineReducers } from 'redux';

import { createResumeReducer as createResume } from 'src/components/Profile/CreateResume/reducer';
import { resumeReducer as resume } from 'src/components/Profile/Resume/reducer';
import { reducer as blend } from 'src/modules/redux-blend';

import { syncingReducer as syncing } from './syncing';

export const rootReducer = combineReducers({
  syncing,
  resume,
  blend,
  createResume,
});
